export default __webpack_public_path__ + "static/media/alphaq.e6f347ea.jpg";